import type { Product } from '@commerce/types/product'
import { memo } from 'react'
import ProductOptionLabel from '../ProductOptionLabel'

interface ProductSiblingOptionProps {
  siblings: Product[]
  selectedSibling: Product | undefined
  setSelectedSibling: React.Dispatch<React.SetStateAction<Product | undefined>>
  currencyCode?: string
}

const ProductSiblingOptions: React.FC<ProductSiblingOptionProps> = ({
  siblings,
  currencyCode = 'AUD',
  selectedSibling,
  setSelectedSibling,
}) => {
  const getProductBasePrice = (sibling: Product) => {
    const productBasePrice = sibling?.variants?.map((v) => v.price)
    return Math.min.apply(null, productBasePrice)
  }
  const bySamplePotQuantities = siblings[1]?.variants?.map((v) => v.name)
  const byLitreQuantites = siblings[3]?.variants?.map((v) =>
    v?.name?.split(' ')?.[0]?.trim()
  )
  const byGardenPotQuantities = siblings[2]?.variants?.map((v) => v.name)
  const quantitySwitch = (index: number) => {
    switch (index) {
      case 0: {
        return ''
      }
      case 1: {
        return bySamplePotQuantities?.join(', ')
      }
      case 2: {
        return byGardenPotQuantities?.join(', ')
      }
      case 3: {
        return byLitreQuantites?.join(', ') + ' litre'
      }
    }
  }
  return (
    <>
      <div>
        {siblings && (
          <div role="listbox" className="flex flex-col gap-4 lg:pb-4">
            {siblings.map((v: Product, i: number) => {
              const name = v?.name?.split('-')?.[1]?.trim()
              const isMultiPrice = v?.variants?.length > 1
              const onClick = () => setSelectedSibling(v)
              if (!name) return null
              return (
                <button onClick={onClick} key={i}>
                  <ProductOptionLabel
                    selected={selectedSibling?.id === v?.id}
                    name={v.siblingOptionLabel}
                    quantity={quantitySwitch(i)}
                    price={getProductBasePrice(v)}
                    currencyCode={currencyCode}
                    multiplePrice={isMultiPrice}
                  />
                </button>
              )
            })}
          </div>
        )}
      </div>
      <style jsx>
        {`
          .input_container {
            display: block;
            position: relative;
            margin-right: 16px;
            cursor: pointer;
            font-size: 13px;
            line-height: 20px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
          }
          .input_container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }
          .checkmark {
            position: absolute;
            top: 2px;
            left: 1px;
            height: 16px;
            width: 16px;
            background-color: #fafafa;
            border: 1px solid #b1b1b1;
            border-radius: 50%;
          }
          .input_container:hover input ~ .checkmark {
            background-color: #fafafa;
            border: 1px solid #646464;
          }
          .checkmark:after {
            content: '';
            position: absolute;
            display: none;
          }
          .input_container input:checked ~ .checkmark:after {
            display: block;
          }
          .input_container .checkmark:after {
            top: 2px;
            left: 2px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #646464;
          }
        `}
      </style>
    </>
  )
}

export default memo(ProductSiblingOptions)
